import DigiSignFiles from './digiSignFiles';
import * as loginStateActions from "../../../actions/actions";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as digiSignStateActions from "../../../actions/digitalsignature/actions";

const mapStateToProps = state => {
    let data = {
        isLoggedIn: state.login.isLoggedIn,
        files: state.digiSignFiles,
    };
    return data;
};

const mapDispatchToProps = dispatch => ({
    getAllDigiSignFiles: (date) => dispatch(digiSignStateActions.getAllDigiSignFiles(date)),
    logout: () => dispatch(loginStateActions.logout()),
    checkIsLoggedIn: () => dispatch(loginStateActions.checkIsLoggedIn()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DigiSignFiles));
